// 4-unit countdown for the "Sale of the Month" banner. Targets the
// last second of the current calendar month and ticks every second.
// When the timer hits zero it auto-rolls to the end of the next month.

(function () {
    const pad = (n) => String(n).padStart(2, '0');

    function endOfMonth(now) {
        const d = new Date(now);
        return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999).getTime();
    }

    function init() {
        const blocks = document.querySelectorAll('[data-sale-countdown]');
        if (!blocks.length) return;
        const els = Array.from(blocks).map((el) => ({
            d: el.querySelector('[data-sale-days]'),
            h: el.querySelector('[data-sale-hours]'),
            m: el.querySelector('[data-sale-mins]'),
            s: el.querySelector('[data-sale-secs]'),
        }));

        let target = endOfMonth(Date.now());

        const tick = () => {
            const now = Date.now();
            let remaining = target - now;
            if (remaining <= 0) {
                target = endOfMonth(now);
                remaining = target - now;
            }
            const days  = Math.floor(remaining / 86_400_000);
            const hours = Math.floor((remaining % 86_400_000) / 3_600_000);
            const mins  = Math.floor((remaining % 3_600_000) / 60_000);
            const secs  = Math.floor((remaining % 60_000) / 1000);

            els.forEach(({ d, h, m, s }) => {
                if (d) d.textContent = pad(days);
                if (h) h.textContent = pad(hours);
                if (m) m.textContent = pad(mins);
                if (s) s.textContent = pad(secs);
            });
        };

        tick();
        setInterval(tick, 1000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
